import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import DefaultGrid from "../Default/DefaultGrid";
import { useFilters } from "../Filters/UseFilter";

interface ModalProps {
  show: boolean;
  onCancel: () => void;
  setFormData: any;
}

const ModalSearchCnpj: React.FC<ModalProps> = ({ show, onCancel, setFormData }) => {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { filters, handleFilterChange } = useFilters([]);

  const columns = [
    { key: "cnpj", label: "CNPJ", filterType: "text" as const },
    { key: "razao", label: "Razão Social", filterType: "text" as const },
    {
      key: "", render: (item: any) => (
        <span className=" d-flex justify-content-center align-items-center ">
          <Button size="sm" className="col-12" onClick={() => selectCliente(item)} variant="secondary"><FontAwesomeIcon icon={faCheck} /></Button>
        </span>

      ), label: <Button size="sm" className="col-12" disabled variant="secondary"><FontAwesomeIcon icon={faCheck} /></Button>
    }
  ]

  const getClient = async () => {
    setLoading(true);
    try {
      const response = await api.get(BackEndRoutes.routes.CLIENTES.LIST);
      if (response.data) {
        setClients(response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
      toast.error("Erro ao buscar clientes.");
    } finally {
      setLoading(false);
    }
  };

  const selectCliente = (item: any) => {
    setFormData((prev: any) => ({
      ...prev,
      cnpj_cliente: item.cnpj
    }))
    onCancel()
    console.log(item)
  }

  useEffect(() => {
    if (show === true) {
      getClient();
    }
  }, [show]);

  return (
    <Modal show={show} size="xl" onHide={onCancel}>
      <Modal.Header closeButton style={{ background: "var(--color-profile-1)", color: "black" }}>
        <Modal.Title>Lista de Clientes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DefaultGrid
          onReload={getClient}
          columns={columns}
          filters={filters}
          handleFilterChange={handleFilterChange}
          items={clients}
        />
      </Modal.Body>
      <Modal.Footer style={{ background: "var(--color-profile-1)" }}>
        <Button
          variant="secondary"
          size="sm"
          disabled={loading}
          onClick={onCancel}
          style={{ display: "flex", alignItems: "center" }}
        >
          {loading ? (
            <Spinner as="span" animation="border" size="sm" />
          ) : (
            <>
              <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "4px" }} /> Voltar
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSearchCnpj;
